export type LogLevel = "debug" | "info" | "warn" | "error";

export type LogContext = unknown;

export type Logger = {
  debug: (message: string, context?: LogContext) => void;
  info: (message: string, context?: LogContext) => void;
  warn: (message: string, context?: LogContext) => void;
  error: (message: string, context?: LogContext) => void;
  child: (scope: string) => Logger;
};

class ConsoleLogger implements Logger {
  constructor(private readonly scope: string) {}

  debug(message: string, context?: LogContext): void {
    // 디버그 로그는 개발 빌드에서만 쓴다. 그래서 운영 콘솔의 불필요한 출력이 줄어든다.
    if (!import.meta.env.DEV) {
      return;
    }
    writeLog("debug", this.scope, message, context);
  }

  info(message: string, context?: LogContext): void {
    writeLog("info", this.scope, message, context);
  }

  warn(message: string, context?: LogContext): void {
    writeLog("warn", this.scope, message, context);
  }

  error(message: string, context?: LogContext): void {
    writeLog("error", this.scope, message, context);
  }

  child(scope: string): Logger {
    return new ConsoleLogger(`${this.scope}/${scope}`);
  }
}

export function createLogger(scope: string): Logger {
  return new ConsoleLogger(scope);
}

function writeLog(level: LogLevel, scope: string, message: string, context?: LogContext): void {
  // 실제 console 호출은 이 함수에 모은다. 그래서 앱 코드는 Logger에만 의존한다.
  const prefix = `[${scope}] ${message}`;

  if (context === undefined) {
    console[level](prefix);
    return;
  }

  console[level](prefix, context);
}
